<template>
    <div>
        <SelectPropertyApplicationModel :show_select_property_application.sync="show_select_property_application" :bank_code="form.bank_code"/>
        <modal :show.sync=show modalClasses="medium-sized-modal" headerClasses="pb-0" :hide-footer="true">
            <h3 slot="header" class="mb-0 font-weight-500 text-center">Add Property Application</h3>
            <b-form role="form" @submit.prevent="addProductApplication">
                <b-row>
                    <b-col cols="12">
                        <b-form-group label="Bank">
                            <el-select v-model="form.bank_code" filterable placeholder="Select" :disabled="selected_property !== null">
                                <el-option
                                v-for="bank in banks"
                                :key="bank.bank_code"
                                :label="bank.bank_name"
                                :value="bank.bank_code"
                                >
                                </el-option>
                            </el-select>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" class="text-center" v-if="form.bank_code && !selected_property">
                        <a href="javascript:void(0)" @click="selectApplicationProperty">Select Property</a>
                    </b-col>
                    <b-row v-if="selected_property" class="p-0 m-0">
                        <b-col cols="12" class="mb-3">
                            <div class="d-flex justify-content-between align-items-center">
                                <div>
                                    <p class="font-weight-bold">Property: {{ this.selected_property.project.project_name }}</p>
                                    <p class="font-weight-bold">Unit: {{ this.selected_property.unit.unit_no }}</p>
                                </div>
                                <a href="javascript:void(0)" @click="changeProject">Change Project</a>
                            </div>
                        </b-col>
                        <b-col cols="6">
                            <b-form-group label="SPA Price (RM)">
                                <b-form-input type="text" v-model="form.spa_price" @keydown="preventNonNumericInput"></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col cols="6">
                            <b-form-group label="Loan Margin (%)">
                                <b-form-input type="text" v-model="form.loan_margin" @keydown="preventNonNumericInput"></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col cols="6">
                            <b-form-group label="Loan Amount (RM)">
                                <b-form-input type="text" v-model="form.loan_amount" @keydown="preventNonNumericInput"></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col cols="6">
                            <b-form-group label="Rebate (%)">
                                <b-form-input type="text" v-model="form.rebate" @keydown="preventNonNumericInput"></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col cols="6">
                            <b-form-group label="Client Net (RM)">
                                <b-form-input type="text" v-model="form.client_nett" @keydown="preventNonNumericInput"></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col cols="6">
                            <b-form-group label="Cash Back (RM)">
                                <b-form-input type="text" v-model="form.cash_back" @keydown="preventNonNumericInput"></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col cols="6">
                            <b-form-group label="Interest (%)">
                                <b-form-input type="text" v-model="form.interest" @keydown="preventNonNumericInput"></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col cols="6">
                            <b-form-group label="Tenure (Years)">
                                <b-form-input type="text" v-model="form.tenure_years" @keydown="preventNonNumericInput"></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col cols="6">
                            <b-form-group label="Instalment (RM)">
                                <b-form-input type="text" v-model="form.installment" @keydown="preventNonNumericInput"></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col cols="6">
                            <b-form-group label="Estimate Rental (RM)">
                                <b-form-input type="text" v-model="form.estimate_rental" @keydown="preventNonNumericInput"></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col md="12" sm="12" class="mx-auto text-center mt-4 pt-2">
                            <b-button type="submit" class="w-100" variant="primary">Add</b-button>
                        </b-col>
                    </b-row>
                </b-row>
            </b-form>
        </modal>
    </div>
</template>
<script>
import Modal from "@/components/Modal"
import { Select, Option } from 'element-ui'
import {axios, services, getHeader, notifyFunctionMixin } from '@/assets/js/httpImports.js'
import {
  calculateInstallment, 
  calculateLoanAmount,
} from '@/assets/js/calculator.js'
import SelectPropertyApplicationModel from "./Partials/SelectPropertyApplicationModel.vue"
import { usePMPStore } from '@/stores/pmpStore'
import { mapActions, mapState } from 'pinia'
import initialProposalEventBus from '@/assets/js/EventBus/initialProposalEventBus.js'

export default {
    props:{
        proposal: Object,
        show_property_application: Boolean,
    },
    mixins: [notifyFunctionMixin],
    components: {
        SelectPropertyApplicationModel,
        Modal,
        [Select.name]: Select,
        [Option.name]: Option,
    },
    computed: {
        show: {
            get() {
                return this.show_property_application;
            },
            set(newVal) {
                this.$emit('update:show_property_application', newVal);
            },
        },
    },
    data() {
        return {
            selected_property: null,
            form: {
                bank_code: '',
                loan_amount: 0,
                spa_price: 0,
                loan_margin: 90,
                rebate: 0,
                rebate_amount: 0,
                client_nett: 0,
                cash_back: 0,
                interest: 0,
                tenure_years: 0,
                installment: 0,
                estimate_rental: 0
            },
            banks:[],
            dsr_bank: null,
            show_select_property_application: false,
        }
    },
    mounted(){
        this.getPMPProjects()
        initialProposalEventBus.$on('selected-proposal-unit', this.selectedProposalProperty);
    },
    beforeUnmount(){
        initialProposalEventBus.$off('selected-proposal-unit', this.selectedProposalProperty)
    },
    watch:{
        show_property_application(newVal){
            if(newVal && this.banks.length === 0){
                this.getBanks()
            }
        },
        'form':{
            handler(newVal){
                if(newVal && this.selected_property){
                    //set loan amount
                    let loan_amount = calculateLoanAmount(newVal.spa_price, newVal.loan_margin)
                    this.form.loan_amount = parseFloat(loan_amount).toFixed(2)

                    //set installment
                    this.form.installment = parseFloat(calculateInstallment(newVal.loan_amount, newVal.interest, newVal.tenure_years)).toFixed(2)

                    // set rebate amount
                    let rebate_amount = (newVal.spa_price * newVal.rebate) / 100
                    this.form.rebate_amount = parseFloat(rebate_amount).toFixed(2)

                    // set client nett
                    let client_nett = newVal.spa_price - rebate_amount
                    this.form.client_nett = parseFloat(client_nett).toFixed(2)

                    // set cashback
                    let cashback = loan_amount - client_nett
                    if(cashback <= 0){
                        cashback = 0
                    }
                    this.form.cash_back = parseFloat(cashback).toFixed(2)

                    //set total arragement fee
                    // let sst_fee = parseFloat(this.form.arrangement_fee) * parseFloat(this.form.arrangement_fee_sst) / 100
                    // let arrangement_fee_amount = parseFloat(this.form.arrangement_fee) + parseFloat(sst_fee)
                    // if(isNaN(arrangement_fee_amount)){
                    //     this.form.arrangement_fee_amount = 0
                    // }else{
                    //     this.form.arrangement_fee_amount = arrangement_fee_amount
                    // }
                }
            },
            deep: true
        },
        'form.bank_code':{
            handler(newVal){
                this.setDSRBank()
                this.$router.replace({query: { ...this.$route.query, bank_code: newVal },},() => {})
            },
        },
    },
    methods: {
        ...mapActions(usePMPStore, ['getPMPProjects']),
        resetForm(){
            this.form.bank_code = ''
            this.form.loan_amount = 0
            this.form.spa_price = 0
            this.form.loan_margin = 90
            this.form.rebate = 0
            this.form.rebate_amount = 0
            this.form.client_nett = 0
            this.form.cash_back = 0
            this.form.interest = 0
            this.form.tenure_years = 0
            this.form.installment = 0
            this.form.estimate_rental = 0
            this.dsr_bank = null
            this.banks = []
            this.selected_property = null
        },
        addProductApplication(){
            const project = this.selected_property.project
            const unit = this.selected_property.unit

            let data = {
                "pcom_psal_id": this.proposal.psal_id,
                "pcom_bank_id": null,
                "pcom_bank_name": this.dsr_bank.bank_name ?? null,
                "pcom_bank_code": this.form.bank_code,
                "pcom_loan_statue": "PROPERTY - "+project.project_name + " ( "+unit.unit_no+")",
                "pcom_credit_limit": null,
                "pcom_final_installment":  this.form.installment,
                "pcom_card_expiry": null,
                "pcom_account_number": null,
                "pcom_remark": null,
                "pcom_product_detail":{
                    "pcp_product_type":"PROPERTY",
                    "pcp_loan_amount": this.form.loan_amount,
                    "pcp_spa_amount": this.form.spa_price,
                    "pcp_max_eligible_amount": null,
                    "pcp_interest_rate": this.form.interest,
                    "pcp_margin_finance": this.form.loan_margin,
                    "pcp_monthly_installment": this.form.installment,
                    "pcp_tenure": this.form.tenure_years,
                    "pcp_rebate_rate":this.form.rebate,
                    "pcp_rebate_amount": this.form.rebate_amount,
                    "pcp_arragement_fee_rate": null,
                    "pcp_arragement_fee_rate_sst": null,
                    "pcp_arragement_fee_amount":null,
                    "pcp_cash_back_amount":this.form.cash_back,
                    "pcp_client_net_amount":this.form.client_nett,
                    "pcp_project_id":project.project_id,
                    "pcp_unit_id":unit.unitno_id,
                    "pcp_project_name": project.project_name,
                    "pcp_project_image_url":project.project_cover_image,
                    "pcp_lease_type":project.project_lease_type_id === 1 ? 'Freehold' : 'Leasehold',
                    "pcp_project_type": project.project_type,
                    "pcp_project_unit_no": unit.unit_no,
                    "pcp_project_json": {
                        "estimate_rental": this.form.estimate_rental,
                        "sqft": unit.built_up,
                        "cb_percent_to_customer": unit.settings.cb_percent_to_customer,

                        "project_location": project.project_location,
                        "fees_spa_legal_fee": unit.unit_fees.unit_fees_sp_agreement,
                        "fees_spa_stamp_duty": unit.unit_fees.unit_fess_sp_stamp_duty,
                        "fees_spa_stamp_disbursement": unit.unit_fees.unit_fess_sp_disbursement,

                        "fees_loan_legal_fee": unit.unit_fees.unit_fees_loan_agreement,
                        "fees_loan_stamp_duty": unit.unit_fees.unit_fees_loan_stamp_duty,
                        "fees_loan_stamp_disbursement": unit.unit_fees.unit_fees_loan_disbursement,

                        "fees_valuation": unit.unit_fees.unit_fess_valuation,
                        "fees_mot": unit.unit_fees.unit_fees_mot,
                        "fees_sinking_fund": unit.unit_fees.unit_fees_sinking_fund,
                        "fees_maintenance": unit.unit_fees.unit_fees_maintenance,
                        "fees_total": unit.unit_fees.unit_fees_total
                    }
                }
            }

            axios.post(services.initial_proposal +'ccris-item', data, {headers:getHeader()})
                .then(res=>{
                    this.notifySuccess('<b>Proposal:</b> - Successfully Added Product.')
                    this.resetForm()
                    initialProposalEventBus.$emit('refresh-proposal-detail')
                    this.$emit('update:show_property_application', false)
                })
                .catch(e=>{
                    this.errorFunction(e)
                })
        },
        changeProject(){
            this.selected_property = null
        },
        selectedProposalProperty(data){
            // close modal
            this.show_select_property_application = false
            // set form
            this.selected_property = data
            this.form.spa_price = data.unit.unit_price
            this.form.rebate = data.unit.settings ? data.unit.settings.cb_percent_to_customer : 0
        },
        selectApplicationProperty(){
            this.show_select_property_application = true
        },
        setDSRBank(){
            this.dsr_bank = this.banks.find(bank => bank.bank_code == this.form.bank_code)
            if(this.dsr_bank ){
                this.form.interest = this.dsr_bank.bank_loan_interest_rate
                this.form.tenure_years = this.dsr_bank.bank_loan_tenure_year
            }else{
                this.form.interest = ''
                this.form.tenure_years = ''
            }
        },
        getBanks(){
            axios.get(services.customer + 'customer/' + this.proposal.psal_customer_id +'/dsr.eligibilities', {headers: getHeader()})
            .then(res=>{
                    this.banks = res.data.data.bank_eligibilities
                })
                .catch(e =>{
                    this.errorFunction(e)
                })
        },
        preventNonNumericInput(event) {
            const keyCode = event.keyCode || event.which;
            const keyValue = String.fromCharCode(keyCode);
            const currencyRegex = /^[\d.,$]+(\.[\d.,$]+)?$/;
            const allowedKeys = [8, 37, 38, 39, 40, 46];
            if (keyCode !== 190 && !currencyRegex.test(keyValue) && !allowedKeys.includes(keyCode)) {
                event.preventDefault();
            }
        },
    }
}
</script>